// 新协议
function kkmhhybrid_log (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "log",
    },
    param: {
      biz: opt.biz,
      tag: opt.tag,
      level: opt.level,
      content: opt.content
    },
    on: true,
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

/**
 * 日志   <br>
 * kkmhhybrid://log，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=238552879}<br>
 * @param {Object} opt 参数对象
 * @param {string} opt.biz 当前页面的名称
 * @param {string} opt.tag 筛选日志用的tag
 * @param {int/str} opt.level 日志级别
 * @param {string} opt.content 日志的内容
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function log(opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion, 583000); 
  if (allow) {
    // 调用新协议
    // 校验
    const err = []
    if (!opt.tag) {
      err.push({key: 'tag ', error: '缺少必填项tag'})
    }
    if (!opt.level) {
      err.push({key: 'level', error: '缺少必填项level'})
    }
    if (!opt.content) {
      err.push({key: 'content', error: '缺少必填项content'})
    }
    if (err.length) {
      console.error(`错误信息===>${JSON.stringify(err)}`)
      return
    }
    kkmhhybrid_log(opt)
  } else {
    console.log('无旧协议')
    // 调用旧协议
  }
}

export default log;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/log/index.js